import { Component, inject } from '@angular/core';
import { ServiceRequestCodePickerComponent } from '../../shared/service-request-code-picker/service-request-code-picker.component';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-service-request-code-picker-dialog',
  imports: [ServiceRequestCodePickerComponent],
  templateUrl: './service-request-code-picker.component.html',
  styleUrls: ['./service-request-code-picker.component.scss']
})
export class ServiceRequestCodePickerDialogComponent {
  dref = inject(MatDialogRef<ServiceRequestCodePickerDialogComponent>);
  onServicePickerChange(event: any) {
    console.log('Service Picker Change Event:', event);
    if (event.category?.code && event.serviceRequestCode?.code) {
      this.dref.close(event);
    }

  }

}
